import { marked } from 'marked';
import DOMPurify from 'dompurify';

export function renderMarkdown(text) {
  return DOMPurify.sanitize(marked.parse(text || ''));
}
